import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-DataSalesGeneral',
    templateUrl: './DataSalesGeneral.component.html',
    styleUrls: ['./DataSalesGeneral.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DataSalesGeneralComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
